import { memo, useState } from 'react';
import vDots from './three-dots-vertical.svg';
import { ButtonDropdown, DropdownToggle } from 'reactstrap';

function VDots({ children }) {
  const [dropdownOpen, setOpen] = useState(false);

  const toggle = () => setOpen(!dropdownOpen);

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} className="btn-more appDropDownMain">
      <DropdownToggle>
        <img src={vDots} alt="Click to select options" />
      </DropdownToggle>
      {children}
    </ButtonDropdown>
  );
}

export default memo(VDots);
